import { render, staticRenderFns } from "./NewTgr.vue?vue&type=template&id=db046860&scoped=true&"
import script from "./NewTgr.vue?vue&type=script&lang=ts&"
export * from "./NewTgr.vue?vue&type=script&lang=ts&"
import style0 from "./NewTgr.vue?vue&type=style&index=0&id=db046860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db046860",
  null
  
)

export default component.exports